export default __webpack_public_path__ + "static/media/PagenotFound.c7736db2.png";